import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { UBItem } from './UBItem';
import { shortenFloat, shortenNumber } from "../../utils/number";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const UBWebMobile = ({id, title, events, successRate = false, total = false, centered, centeredTitle, titleStatus, eventsStatus, sectioned = false }) => {
  return (
      <UBItem id={id} title={title} centered={centered} centeredTitle={centeredTitle} titleStatus={titleStatus} childrenStatus={eventsStatus} styles={{}}>
        <Grid container spacing={2} py={2} px={1}>
            <Grid sm={centered ? 4 : total && successRate ? 4 : successRate ? 3 : 6} md={centered ? 4 : total && successRate ? 4 : successRate ? 3 : 6}></Grid>

            <Grid sm={total && successRate ? 2 : 3} md={total && successRate ? 2 : 3} display="flex" alignItems="center" justifyContent="right">
                  <Typography align="right">{id === "otp" ? "Email" : id === "transfers" ? "Attempt" : "Web"}</Typography>
            </Grid>

            <Grid sm={total && successRate ? 2 : 3} md={total && successRate ? 2 : 3} display="flex" alignItems="center" justifyContent="right">
                  <Typography align="right">{id === "transfers" ? "Success" : "Mobile"}</Typography>
            </Grid>

            {total &&
                <Grid sm={total && successRate ? 2 : 3} md={total && successRate ? 2 : 3} display="flex" alignItems="center" justifyContent="right">
                    <Typography align="right">Total</Typography>
                </Grid>
            }

            {successRate &&
                <Grid sm={total && successRate ? 2 : 3} md={total && successRate ? 2 : 3} display="flex" alignItems="center" justifyContent="right">
                    <Tooltip title={<Typography>{'CTA and General Enrollment: Success Rate = (Credential Creation / Identification Attempt - Already Enrolled). FTE: Success Rate = (Credential Creation / SSO - Already Enrolled).'}</Typography>}>
                        <IconButton>
                            <InfoOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                    
                    <Typography align="right">Success Rate</Typography>
                </Grid>
            }

            {centered &&
                <Grid sm={2} md={2}>
                </Grid>
            }

            {events?.map(event => {
                return (
                    <>
                        {sectioned && event?.web === undefined && event?.mobile === undefined ?
                            <Grid sm={12} md={12}>
                                <Typography align="left">{event?.event?.label}</Typography>
                            </Grid>
                            :
                            <>
                                <Grid sm={centered ? 4 : total && successRate ? 4 : successRate ? 3 : 6} md={centered ? 4 : total && successRate ? 4 : successRate ? 3 : 6} pl={sectioned ? 3 : 0}>
                                    <Box display="flex" alignItems="center" justifyContent="right" px={1}>
                                        {event?.event?.tooltip &&
                                            <Tooltip title={<Typography>{event?.event?.tooltip}</Typography>}>
                                                <IconButton>
                                                    <InfoOutlinedIcon />
                                                </IconButton>
                                            </Tooltip>
                                        }
                                        
                                        <Typography align={centered ? "center" : "right"}>{event?.event?.label}</Typography>
                                    </Box>
                                </Grid>

                                <Grid sm={total && successRate ? 2 : 3} md={total && successRate ? 2 : 3} display="flex" alignItems="center" justifyContent="right">
                                    <Typography align="right">{shortenNumber(event?.web)}</Typography>
                                </Grid>

                                <Grid sm={total && successRate ? 2 : 3} md={total && successRate ? 2 : 3} display="flex" alignItems="center" justifyContent="right">
                                    <Typography align="right">{shortenNumber(event?.mobile)}</Typography>
                                </Grid>

                                {total &&
                                    <Grid sm={total && successRate ? 2 : 3} md={total && successRate ? 2 : 3} display="flex" alignItems="center" justifyContent="right">
                                        <Typography align="right">{shortenNumber(event?.total)}</Typography>
                                    </Grid>
                                }

                                {successRate &&
                                    <Grid sm={total && successRate ? 2 : 3} md={total && successRate ? 2 : 3} display="flex" alignItems="center" justifyContent="right">
                                        <Typography align="right">{`${shortenFloat(event?.successRate)}%`}</Typography>
                                    </Grid>
                                }

                                {centered &&
                                    <Grid sm={2} md={2}>
                                    </Grid>
                                }
                            </>
                        }
                    </>
                );
            })}
        </Grid>
    </UBItem>
  );
};
